module.exports = __webpack_public_path__ + "img/ico_usuario-30.c408982e.svg";